'use strict';

intellidealerAppCoreModule.factory('worldpayUrlService', function ($window, locationService) {

  var ORDER_DETAILS_KEY = '_worldpayOrderDetails';
  var RETURN_HASH_KEY = '_worldpayReturnHash';
  var INVOICE_PAYMENT_DETAILS_KEY = '_worldpayInvoicePaymentDetails';
  var INVOICE_PAYMENT_APPLY_WRAPPER_KEY = '_worldpayInvoicePaymentApplyWrapper';
  var CART_REF_KEY = '_worldpayCartRefNum';
  var PICKUP_LOCATION_KEY = '_worldpayPickupLocation';
  var CART_REF_LOCAL_KEY = '_cartRefNum';

  function isWorldpayReturnSearch(search) {
    return /TransactionSetupID=|ExpressResponseCode=|HostResponseCode=|HostedPaymentStatus=|SalesOrderNumber=|errorRefNumber=|ErrorRefNumber=/.test(search);
  }

  function readFromStorage(key) {
    try {
      return localStorage.getItem(key) || sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeToStorage(key, value) {
    try {
      localStorage.setItem(key, value);
      sessionStorage.setItem(key, value);
    } catch (e) { /* ignore quota / private mode */ }
  }

  function removeFromStorage(key) {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (e) { /* ignore */ }
  }

  function isCartReferenceNumber(referenceNumber) {
    return !!referenceNumber &&
      (referenceNumber.indexOf('*PCART*') === 0 || referenceNumber.indexOf('**CART**') === 0);
  }

  function getStoredCartReferenceFromOrderDetails() {
    try {
      var stored = readFromStorage(ORDER_DETAILS_KEY);
      if (stored) {
        var orderDetails = JSON.parse(stored);
        if (orderDetails.cartReferenceNumber) {
          return orderDetails.cartReferenceNumber;
        }
        // Backward compat: older Worldpay sessions stored the cart ref in referenceNumber.
        if (isCartReferenceNumber(orderDetails.referenceNumber)) {
          return orderDetails.referenceNumber;
        }
      }
    } catch (e) { /* ignore */ }
    return null;
  }

  function restoreCartReference() {
    var cartRef = readFromStorage(CART_REF_KEY) || localStorage.getItem(CART_REF_LOCAL_KEY) ||
      getStoredCartReferenceFromOrderDetails();
    if (cartRef) {
      try {
        localStorage.setItem(CART_REF_LOCAL_KEY, cartRef);
        writeToStorage(CART_REF_KEY, cartRef);
      } catch (e) { /* ignore */ }
    }
  }

  return {

    clearReturnSearchParams: function (hashOverride) {
      var search = $window.location.search || '';
      var hashPath = hashOverride || ($window.location.hash || '').split('?')[0] || readFromStorage(RETURN_HASH_KEY);
      if (isWorldpayReturnSearch(search) && hashPath) {
        $window.history.replaceState(null, '', $window.location.pathname + hashPath);
      }
    },

    getStoredOrderDetails: function () {
      return readFromStorage(ORDER_DETAILS_KEY);
    },

    getStoredInvoicePaymentDetails: function () {
      return readFromStorage(INVOICE_PAYMENT_DETAILS_KEY);
    },

    hasPendingInvoicePayment: function () {
      return !!readFromStorage(INVOICE_PAYMENT_DETAILS_KEY);
    },

    persistInvoicePaymentSession: function (paymentDetails) {
      removeFromStorage(INVOICE_PAYMENT_APPLY_WRAPPER_KEY);
      writeToStorage(INVOICE_PAYMENT_DETAILS_KEY, JSON.stringify(paymentDetails));
      var returnHash = ($window.location.hash || '').split('?')[0];
      writeToStorage(RETURN_HASH_KEY, returnHash);
    },

    clearInvoicePaymentSession: function () {
      removeFromStorage(INVOICE_PAYMENT_DETAILS_KEY);
      removeFromStorage(RETURN_HASH_KEY);
      removeFromStorage(INVOICE_PAYMENT_APPLY_WRAPPER_KEY);
    },

    persistInvoicePaymentApplyWrapper: function (wrapper) {
      writeToStorage(INVOICE_PAYMENT_APPLY_WRAPPER_KEY, JSON.stringify(wrapper));
    },

    getStoredInvoicePaymentApplyWrapper: function () {
      try {
        var stored = readFromStorage(INVOICE_PAYMENT_APPLY_WRAPPER_KEY);
        return stored ? JSON.parse(stored) : null;
      } catch (e) {
        return null;
      }
    },

    getStoredReturnHash: function () {
      return readFromStorage(RETURN_HASH_KEY);
    },

    persistCheckoutSession: function (orderDetails) {
      writeToStorage(ORDER_DETAILS_KEY, JSON.stringify(orderDetails));
      var returnHash = ($window.location.hash || '').split('?')[0];
      writeToStorage(RETURN_HASH_KEY, returnHash);

      var cartRef = localStorage.getItem(CART_REF_LOCAL_KEY);
      if (!cartRef && orderDetails && orderDetails.cartReferenceNumber) {
        cartRef = orderDetails.cartReferenceNumber;
      }
      if (cartRef) {
        try {
          localStorage.setItem(CART_REF_LOCAL_KEY, cartRef);
        } catch (e) { /* ignore */ }
        writeToStorage(CART_REF_KEY, cartRef);
      }

      if (orderDetails && orderDetails.location) {
        writeToStorage(PICKUP_LOCATION_KEY, orderDetails.location);
      }
    },

    syncPickupLocation: function (location) {
      if (!location) {
        return;
      }
      locationService.setDefaultLocation(location);
      writeToStorage(PICKUP_LOCATION_KEY, location);
    },

    restoreCheckoutContext: function (clearLocationIfNoCart) {
      restoreCartReference();

      var checkoutLocation = this.getStoredCheckoutLocation();
      if (checkoutLocation) {
        locationService.setDefaultLocation(checkoutLocation);
      } else if (clearLocationIfNoCart && !readFromStorage(CART_REF_KEY) && !localStorage.getItem(CART_REF_LOCAL_KEY) &&
        !getStoredCartReferenceFromOrderDetails()) {
        locationService.clearDefaultLocation();
      }
    },

    clearCheckoutSession: function (includePickupLocation) {
      removeFromStorage(ORDER_DETAILS_KEY);
      removeFromStorage(RETURN_HASH_KEY);
      removeFromStorage(CART_REF_KEY);
      if (includePickupLocation) {
        removeFromStorage(PICKUP_LOCATION_KEY);
      }
    },

    hasPendingCheckoutReturn: function () {
      return !!readFromStorage(ORDER_DETAILS_KEY);
    },

    hasStashedPortalReturnParams: function () {
      try {
        return !!sessionStorage.getItem('_worldpayReturnParams');
      } catch (e) {
        return false;
      }
    },

    isActiveCheckoutReturn: function () {
      return this.hasPendingCheckoutReturn() || this.hasStashedPortalReturnParams();
    },

    getStoredCheckoutLocation: function () {
      try {
        var stored = readFromStorage(ORDER_DETAILS_KEY);
        if (stored) {
          var location = JSON.parse(stored).location;
          if (location) {
            return location;
          }
        }
      } catch (e) { /* ignore */ }
      if (readFromStorage(ORDER_DETAILS_KEY) || readFromStorage(CART_REF_KEY)) {
        return readFromStorage(PICKUP_LOCATION_KEY);
      }
      return null;
    },

    getStoredCartReference: function () {
      return readFromStorage(CART_REF_KEY) || localStorage.getItem(CART_REF_LOCAL_KEY) ||
        getStoredCartReferenceFromOrderDetails();
    },

    isCartReferenceNumber: isCartReferenceNumber,

    prepareOrderDetailsForCheckout: function (orderDetails) {
      var checkoutDetails = angular.copy(orderDetails || {});
      delete checkoutDetails.cartReferenceNumber;
      if (isCartReferenceNumber(checkoutDetails.referenceNumber)) {
        delete checkoutDetails.referenceNumber;
      }
      return checkoutDetails;
    }
  };
});
